import { useState } from "react";
import { CommonInfo } from "../../CommonData/Config";
import './BookingActionButton.css';

type BookingActionButtonProps = {
  theme: string;
  icon: string;
  label: string;
  bgColor: string;
  isCancel?: boolean;
  onClick: () => void;
}
const BookingActionButton = ({
  theme,
  icon,
  label,
  bgColor,
  isCancel = false,
  onClick,
}: BookingActionButtonProps) => {

  const [hovered, setHovered] = useState(false);

  return (
    <div
      className={"action-btn"}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ backgroundColor: bgColor, border: isCancel ? theme === "dark" ? "1px dashed #FFFFFF" : "1px dashed #000" : "0px transparent" }}
      onClick={onClick}
    >
      <img src={`${CommonInfo.folderName}${icon}`} className="action-icon" />
      {hovered && <span className={theme === "dark" ? "action-text-light" : "action-text"}>{label}</span>}
    </div>
  );
};

export default BookingActionButton;
